
export class BulkLabelDeleteRequest {
    labelIds: number[] = [];
}